import axios from "axios";
export const state = {
    save_status: false,
    filter_status: false,
    market_products: [],
    units: [],
    market_categories: [],
};

export const getters = {
    saveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,
    MarketProducts: state => state.market_products.data,
    Units: state => state.units.data,
    MarketCategories: state => state.market_categories,
};

export const mutations = {
    SET_SAVE_STATUS(state, newValue){
        state.save_status = newValue
    },
    SET_FILTER_STATUS(state, newValue){
        state.filter_status = newValue
    },
    SET_MARKET_PRODUCTS(state, newValue){
        state.market_products = newValue
    },
    SET_UNITS(state, newValue){
        state.units = newValue
    },
    SET_MARKET_CATEGORIES(state, newValue){
        state.market_categories = newValue
    }
};

export const actions = {
    fetchMarketProducts({commit}, payload){
        axios.get('market_products',{
            params: payload
        }).then(ec_res => {
            commit('SET_MARKET_PRODUCTS', ec_res.data)
        })
    },

    fetchUnits({ commit }) {
        axios.get('units').then(ec_res => {
            commit('SET_UNITS', ec_res.data)
        })
    },
    fetchMarketCategories({ commit }) {
        axios.get(`fetch_marketplace_categories`).then(ec_res => {
            commit('SET_MARKET_CATEGORIES', ec_res.data)
        })
    },

    addMarketProduct({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('market_products', payload).then((res) => {
            commit('SET_SAVE_STATUS', false);             
            if (res.status == 200) {
                dispatch('fetchMarketProducts', );
                let message = { 'msg': `Product ${payload.name} added successfully` }
                dispatch('notification/success', message, { root: true })
            } else if (res.status == 202) {
                let message = { 'msg': res.data.message }
                dispatch('notification/error', message, { root: true })
            }     
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Product " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Product
    editMarketProduct({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`market_products/${payload.id}`, payload).then((res) => {
            commit('SET_SAVE_STATUS', false);
            if (res.status == 200) {
                dispatch('fetchMarketProducts');
                let message = { 'msg': `Product ${payload.name} updated successfully` }
                dispatch('notification/success', message, { root: true })
            } else if (res.status == 202) {
                let message = { 'msg': res.data.message }
                dispatch('notification/error', message, { root: true })
            }             
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Product" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Product
    deleteMarketProduct({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`market_products/${payload.id}`).then(() => {
            dispatch('fetchMarketProducts');
            let message = { 'msg': `Product ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Product Categories
    addMarketProductCategory({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('add_marketplace_categories', payload).then((res) => {
            commit('SET_SAVE_STATUS', false);             
            if (res.status == 200) {
                dispatch('fetchMarketCategories', );
                let message = { 'msg': `Product Category ${payload.name} added successfully` }
                dispatch('notification/success', message, { root: true })
            } else if (res.status == 202) {
                let message = { 'msg': res.data.message }
                dispatch('notification/error', message, { root: true })
            }     
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Product Category " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Product Category
    editMarketProductCategory({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`edit_marketplace_categories/${payload.id}`, payload).then((res) => {
            commit('SET_SAVE_STATUS', false);
            if (res.status == 200) {
                dispatch('fetchMarketCategories');
                let message = { 'msg': `Product Category ${payload.name} updated successfully` }
                dispatch('notification/success', message, { root: true })
            } else if (res.status == 202) {
                let message = { 'msg': res.data.message }
                dispatch('notification/error', message, { root: true })
            }             
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Product Category" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Product Category
    deleteMarketProductCategory({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`delete_marketplace_categories/${payload.id}`).then(() => {
            dispatch('fetchMarketCategories');
            let message = { 'msg': `Product Category ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
};